export const getRepositories = (state) => state.repositories;
export const getSelectedRepositoryId = (state) => state.selectedRepositoryId;
export const getSelectedFolderId = (state) => state.selectedFolderId;
export const getSelectedElement = (state) => state.selectedElement;
export const getTreeElements = (state) => state.foldersStack;
export const getFilesStack = (state) => state.filesStack;
export const getPermissionsStack = (state) => state.permissionsStack;
export const getSubscriptionsStack = (state) => state.subscriptionsStack;
export const loading = (state) => !!state.loading;
export const loadingElements = (state) => !!state.loadingElements;
export const loadingTemplates = (state) => !!state.loadingTemplates;
export const approvals = (state) => state.approvals;
export const previousVersions = (state) => state.previousVersions;
